// requires: bootstrap-select/bootstrap.bundle.js bootstrap-select/bootstrap-select.min.js

var $ = jQuery;

$('document').ready(function () {

    const us_states = {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        DC: "District of Columbia",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming",
        AS: "American Samoa",
        AE: "Armed Forces Africa / Canada / Europe / Middle East",
        AA: "Armed Forces Americas",
        AP: "Armed Forces Pacific",
        FM: "Federated States of Micronesia",
        GU: "Guam",
        MP: "Northern Mariana Islands",
        PR: "Puerto Rico",
        MH: "Republic of Marshall Islands",
        VI: "Virgin Islands of the U.S."
    };

    const ca_states = {
        AB: "Alberta",
        BC: "British Columbia",
        MB: "Manitoba",
        NB: "New Brunswick",
        NL: "Newfoundland and Labrador",
        NT: "Northwest Territories",
        NS: "Nova Scotia",
        NU: "Nunavut",
        ON: "Ontario",
        PE: "Prince Edward Island",
        QC: "Quebec",
        SK: "Saskatchewan",
        YT: "Yukon"
    };

    const us_state_taxes = {
        AK: 0.0154,
        AL: 0.0836,
        AR: 0.0857,
        AZ: 0.0787,
        CA: 0.0826,
        CO: 0.0647,
        CT: 0.0635,
        DC: 0.0575,
        DE: 0.0000,
        FL: 0.0682,
        GA: 0.0733,
        HI: 0.0424,
        IA: 0.0689,
        ID: 0.0604,
        IL: 0.0750,
        IN: 0.0700,
        KS: 0.0805,
        KY: 0.0600,
        LA: 0.0958,
        MA: 0.0625,
        MD: 0.0600,
        ME: 0.0550,
        MI: 0.0600,
        MN: 0.0718,
        MO: 0.0728,
        MS: 0.0702,
        MT: 0.0000,
        NC: 0.0690,
        ND: 0.0551,
        NE: 0.0586,
        NH: 0.0000,
        NJ: 0.0663,
        NM: 0.0703,
        NV: 0.0778,
        NY: 0.0819,
        OH: 0.0710,
        OK: 0.0786,
        OR: 0.0000,
        PA: 0.0610,
        PR: 0.1150,
        RI: 0.0700,
        SC: 0.0736,
        SD: 0.0560,
        TN: 0.0950,
        TX: 0.0744,
        UT: 0.0661,
        VA: 0.0546,
        VT: 0.0604,
        WA: 0.0876,
        WI: 0.0546,
        WV: 0.0610,
        WY: 0.0529
    };

    // Change order + addon summary table on page ready
    $initial_data = getSelectedOption();
    $initial_data['row_class'] = 'main-item';
    writeToOrderAddonTable($initial_data, 'w');
    displayShippingPrice();
    updateAddonTableTotal();

    // Initiate select picker
    $('.st-bootstrap-select').selectpicker();

    $('#chkForm').submit(function (e) {
        var valid = true;
        jQuery('input, select', jQuery('#chkForm')).each(function (i, v) {
            valid = checkout_steps_validator.element(v) && valid;
        });
        
        if (!valid)
            return;
        
        let postalCode = jQuery('[name="shipping_postalCode"]').val();
        if (countryzip(postalCode) === false) {
            e.preventDefault();
            swal({
                title: "Validation Failed",
                text: 'Please Enter A 5 or 9 Digit Zip Code',
                closeOnClickOutside: true
            });
            return false;
        } else {
            st_loader.toggle();
            return true;
        }
    });

    $("#digital-check").click(function () {
        toggleShippingInsurance();
    });
    $('.bump-checkbox').on('change', function () {
        if ($(this).is(':checked')) {
            $(this).parents('.crossItem').find('.fa').removeClass('fa-square-o').addClass('fa-check-square');
            writeToOrderAddonTable({item_name: $(this).attr('title'), item_price: '$' + $(this).data('price')});
            updateAddonTableTotal();
        } else {
            $(this).parents('.crossItem').find('.fa').removeClass('fa-check-square').addClass('fa-square-o');
            removeItemFromAddonTable($(this).attr('title'));
            updateAddonTableTotal();
        }
    });

    jQuery(document).on('change', '[name="product1_id"]', function () {
        let data = getSelectedOption();
        data['row_class'] = "main-item";
        updateMainItemOnAddonTable(data);
        displayShippingPrice();
        updateAddonTableTotal();
    });

    function toggleShippingInsurance() {
        $table_body = jQuery('#order-addon-summary-table-body');
        if (jQuery('#digital-check').is(':checked')) {
            writeToOrderAddonTable({
                'item_name': jQuery('#digital-check').data('heading'),
                'item_price': '$' + jQuery('#digital-check').data('price'),
                'row_class': 'shipping_insurance'
            });
        } else {
            jQuery($table_body).find('.shipping_insurance').remove();
        }
        updateAddonTableTotal();
    }

    function displayShippingPrice() {
        jQuery('#shipping_total').html(getShippingPrice());
    }

    function getShippingPrice() {
        let price = jQuery('[name="product1_id"]:checked, #selected_option').data('shipping-price');
        if (price > 0) {
            return '$' + price.toFixed(2);
        } else {
            return 'FREE';
        }
    }

    function updateMainItemOnAddonTable($data) {
        let tr = jQuery('#order-addon-summary-table-body tr.main-item');
        jQuery(tr).empty().append(jQuery(
                `<td><label>` + $data.item_name + `</label></td>
                 <td>` + $data.item_price + `</td>`
                ));
    }

    function updateAddonTableTotal() {
        let total = 0;
        let texts = [];
        $('#order-addon-summary-table-body tr').each(function () {
            texts.push($(this).find('td:last-of-type').text());
        });
        // Adding Shipping cost to calculatable list
        texts.push($('#shipping_total').text());
        for (key in texts) {
            let sanitized_text = parseFloat(texts[key].replace('$', ''));
            if (!isNaN(sanitized_text)) {
                total += sanitized_text;
            }
        }
        $('#cart_total').attr('total', total.toFixed(2));
        $('#cart_total').text('$' + (total.toFixed(2)));
        $('#checkout_total').val(total.toFixed(2));
        getTaxRate(jQuery('#state'));
    }

    function writeToOrderAddonTable($data, $type) {
        $type = $type || 'a'; //append 
        $table_body = jQuery('#order-addon-summary-table-body');
        if ($type === 'w') {
            jQuery($table_body).empty();
        }
        $tr_class = $data.row_class || '';
        jQuery($table_body).append(jQuery(
                `<tr class="` + $tr_class + `">
                    <td>
                        <label >` + $data.item_name + `</label>
                    </td>
                    <td>` + $data.item_price + `</td>
                </tr>`
                ));
    }

    function removeItemFromAddonTable(title) {
        $('#order-addon-summary-table-body tr:contains("' + title + '")').remove();
    }

    function getSelectedOption() {
        let price = 'FREE';
        if (jQuery('[name="product1_id"]:checked, #selected_option').data('item-price') > 0) {
            price = '$' + jQuery('[name="product1_id"]:checked, #selected_option').data('item-price');
        }

        let $table_data = {
            'item_name': jQuery('[name="product1_id"]:checked, #selected_option').attr('title'),
            'item_price': price
        };
        return $table_data;
    }

    jQuery('[name="phoneNumber"]').on('blur', function () {
        let contactNumber = jQuery(this).val();
        jQuery(this).val(formatContactNumber(contactNumber));
    });

    function formatContactNumber(nStr) {
        let numbers_only = nStr.replace(/[- )(A-Za-z\+~`!@#$%^&*_=;:'"<>?,.\[\]{}|\\]/g, ''); //Allow only numbers/integers
        return numbers_only;
    }

    jQuery('[name="shipping_postalCode"]').on('blur', function () {
        let postalCode = jQuery(this).val();
        if (countryzip(postalCode) === false) {
            jQuery('[name="shipping_postalCode"]').css('background-color', '#ffcbcb');
        } else {
            jQuery('[name="shipping_postalCode"]').removeAttr('style');
        }
    });

    function countryzip(zip) {
        var country = jQuery('[name="shipping_country"]').val();

        if (country === "US") {
            if (zip.match(/\d{5}(-| |.|)\d{4}$|\d{5}(-| |.|)\d{4}(-| |.|)\d{2}$|^\d{5}$/)) {
                let zipcode = zip.replace(/[- .)(A-Za-z\+]/g, '');

                if (zipcode.length > 11) {
                    return false;
                }

                if (zipcode.length > 5 && zipcode.length < 10) {
                    zipcode = zipcode.substr(0, 5) + '-' + zipcode.substr(5, zipcode.length);
                } else if (zipcode.length > 10) {
                    zipcode = zipcode.substr(0, 5) + '-' + zipcode.substr(5, 4) + '-' + zipcode.substr(9, zipcode.length);
                }
                jQuery('[name="shipping_postalCode"]').val(zipcode);
                return true;
            }

        } else {
            if (zip.match(/[a-zA-Z]\d{1}[a-zA-Z](-| |)\d{1}[a-zA-Z]\d{1}$/)) {
                let zipcode = zip.replace(/[-| | )(\+]/g, '');
                if (zipcode.length > 3) {
                    zipcode = zipcode.substr(0, 3) + ' ' + zipcode.substr(3, zipcode.length);
                    jQuery('[name="shipping_postalCode"]').val(zipcode);
                }
                return true;
            } else {
                return false;
            }
        }
        return false;
    }

    function getTaxRate(state) {
        let selectedState = jQuery(state).find('option:selected').val();
        let taxRate = (us_state_taxes[selectedState] === undefined) ? 0 : us_state_taxes[selectedState];
        let taxTotal = jQuery('#cart_total').attr('total') * taxRate;
        jQuery('#tax_total').text('$' + taxTotal.toFixed(2));
        let cartTotal = jQuery('#cart_total').attr('total') * (1 + taxRate);
        if (typeof calculate_tax !== 'undefined' && calculate_tax === true) {
            jQuery('#cart_total').text('$' + cartTotal.toFixed(2));
        }
        return taxRate.toFixed(4);
    }

    let select = {
        populateStates: function (country_selected, state_dropdown) {
            let selected_country = jQuery(country_selected).find('option:selected').val();
            let state_select = jQuery(state_dropdown);
            state_select.empty();

            let states = us_states;
            if (selected_country === "CA") {
                states = ca_states;
                jQuery('<option></option>').attr('value', '').text('-- Select Province --').appendTo(state_select);
            } else {
                jQuery('<option></option>').attr('value', '').text('-- Select State --').appendTo(state_select);
            }

            $.each(states, function (key, value) {
                jQuery('<option></option>').attr('value', key).text(value).appendTo(state_select);
            });
            jQuery(state_select).selectpicker("refresh");
            getTaxRate(jQuery('#state'));
        },
        toggleDifferentShipping: function () {
            if (jQuery('input[name="different_shipping"]').is(':checked')) {
                this.toggleBillingRequired(false);
                jQuery('.shipping-details').hide(100);
            } else {
                this.toggleBillingRequired(true);
                jQuery('.shipping-details').show(100);
            }
        },
        toggleBillingRequired: function(toggleStatus = true) {
            jQuery('[name="address1"]').prop('required', toggleStatus);
            jQuery('[name="city"]').prop('required', toggleStatus);
            jQuery('[name="state"]').prop('required', toggleStatus);
            jQuery('[name="postalCode"]').prop('required', toggleStatus);
        }
    };

    var variant_id = 0;
    let varient = {
        create_hidden_input: function () {
            this.remove_hidden_input();
            let selected_option = jQuery('input[name="product1_id"]:checked');
            jQuery('<input>').attr({type: 'hidden', name: 'product1_price', value: selected_option.data('item-price')}).appendTo('.variation');
            jQuery('<input>').attr({type: 'hidden', name: 'product1_shipPrice', value: selected_option.data('shipping-price')}).appendTo('.variation');

            if (this.variant_available()) {
                jQuery('<input>').attr({type: 'hidden', name: 'variant1_id', value: variant_id}).appendTo('.variation');
            }
        },
        remove_hidden_input: function () {
            jQuery('.variation input').remove();
        },
        variant_available: function () {
            variant_id = jQuery('input[name="product1_id"]:checked').data('variant');
            if (variant_id > 0) {
                return true;
            } else {
                return false;
            }
        }
    };

    // populate initialy selected country states
    select.populateStates('#country', '#state');
    select.populateStates('#shipping_country', '#shipping_state');
    select.toggleDifferentShipping();

    jQuery('#country').on('change', function () {
        select.populateStates('#country', '#state');
    });

    jQuery('#state').on('change', function () {
        getTaxRate(jQuery('#state'));
    });

    jQuery('#shipping_country').on('change', function () {
        select.populateStates('#shipping_country', '#shipping_state');
    });

    jQuery('input[name="different_shipping"]').on('change', function () {
        select.toggleDifferentShipping();
    });

    varient.create_hidden_input();
    jQuery('input[name="product1_id"]').on('change', function () {
        varient.create_hidden_input();
    });


    /* New code added for sticky footer feature */
    function toggleStickyFooter() {
        $topOffset = jQuery(window).scrollTop();
        if ($topOffset > 700 && jQuery(window).scrollTop() + jQuery(window).height() <= (jQuery(document).height() - 350)) {
            jQuery('.st-checkout-footer').fadeIn(400);
        } else {
            jQuery('.st-checkout-footer').fadeOut(250);
        }
    }
    toggleStickyFooter();
    jQuery(window).scroll(function () {
        toggleStickyFooter();
    });
    /* Sticky footer feature ends */

    /* Begin Checkout V2 Scripts */

    var checkout_steps = {
        checkoutForm: {
            rules: {
                firstName: {
                    required: true
                },
                lastName: {
                    required: true
                },
                emailAddress: {
                    required: true,
                    email: true
                },
                phoneNumber: {
                    required: true
                },
                shipping_address1: {
                    required: true
                },
                shipping_city: {
                    required: true
                },
                shipping_state: {
                    required: true
                },
                shipping_postalCode: {
                    required: true
                },
                country: {
                    required: true
                },
                cardNumber: {
                    required: true
                },
                cardSecurityCode: {
                    required: true
                },
                cardMonth: {
                    required: true
                },
                cardYear: {
                    required: true
                }
            },
            messages: {
                firstName: {
                    required: "First Name Required"

                },
                lastName: {
                    required: "Last Name Required"
                },
                emailAddress: {
                    required: "Email Address Required"
                },
                phoneNumber: {
                    required: "Phone Number Required"
                },
                address1: {
                    required: "Address Line 1 Required"
                },
                shipping_address1: {
                    required: "Shipping Address Line 1 Required"
                },
                city: {
                    required: "City Required"
                },
                shipping_city: {
                    required: "Shipping City Required"
                },
                state: {
                    required: "This field is required."
                },
                postalCode: {
                    required: "Postal Code Required"
                },
                shipping_postalCode: {
                    required: "Shipping Postal Code Required"
                },
                country: {
                    required: "Country Required"
                },
                cardNumber: {
                    required: "Card Number Required"
                },
                cardSecurityCode: {
                    required: "CVC Required"
                },
                cardMonth: {
                    required: "Expiry Month Required"
                },
                cardYear: {
                    required: "Expiry Year Required"
                }
            }
        },
        step_two: function () {
            //this.toggleLoading();
            jQuery.ajax({
                url: 'index.php',
                type: 'POST',
                data: {step: 'opt-in', email: jQuery("[name='emailAddress']").val()},
                success: function (result) {
                    //console.log(result);
                },
                complete: function (jqXHR, textStatus) {
                    //checkout_steps.toggleLoading();
                }
            });
            // Go to last tab
            jQuery('#checkout-tabs a[href="#size"]').removeClass("disabled").tab("show");
            jQuery("html, body").animate({
                scrollTop: jQuery("#checkout-tabs").offset().top
            }, "slow");
        },
        // Keep selected option field number recorded
        recordSelectedSizefield: function () {
            let selected_option = jQuery('input[name="product1_id"]:checked');
            jQuery('input[name="upsell_product1_id"]').val(selected_option.data('upsell-product-id'));
            jQuery('input[name="upsell_variant1_id"]').val(selected_option.data('upsell-variant-id'));
        }
    };

    // Checkout Options on change    
    checkout_steps.recordSelectedSizefield();
    jQuery('input[name="product1_id"]').on('change', function (e) {
        checkout_steps.recordSelectedSizefield();
    });

    // Form Validator
    var checkout_steps_validator = jQuery('#chkForm').validate({
        ignore: 'input[type="button"],input[type="submit"]',
        rules: checkout_steps.checkoutForm.rules,
        errorPlacement: function (error, element) {
            error.insertAfter(element);
            element.addClass('err');
        },
        messages: checkout_steps.checkoutForm.messages,
        errorClass: "st-error",
        validClass: "success",
        errorElement: 'div'

    });

    jQuery('#checkout-next-step').on('click', function (e) {
        e.preventDefault();
        var tab = jQuery(".tab-pane.active");
        var valid = true;
        jQuery('input, select', tab).each(function (i, v) {
            valid = checkout_steps_validator.element(v) && valid;
        });

        if (!valid) {
            return;
        } else {
            checkout_steps.step_two();
        }

    });
    jQuery('.checkout-v2 .checkout button.submit-button').on('click', function (e) {
        e.preventDefault();
        var tab = jQuery(".tab-pane.active");
        var valid = true;
        jQuery('input', tab).each(function (i, v) {
            valid = checkout_steps_validator.element(v) && valid;
        });

        if (!valid) {
            return;
        } else {
            jQuery('#chkForm').submit();
        }

    });

    /* End Checkout V2 Scripts */


});
